import React, {Component} from 'react';
import {Button, Modal, ModalBody, ModalFooter, ModalHeader} from 'reactstrap';
import {Redirect} from 'react-router-dom';

const withErrorHandler = (WrappedComponent, axios) => {
    return class extends Component {
        state = {
            error: null,
        };

        componentDidMount() {
            this.reqInterceptor = axios.interceptors.request.use(req => {
                this.setState({error: null});
                return req;
            });
            this.resInterceptor = axios.interceptors.response.use(
                res => res,
                error => {
                    if (error.response && error.response.status !== 405)
                        this.setState({error: error});

                    return Promise.reject(error);
                }
            );
        }

        componentWillUnmount() {
            axios.interceptors.request.eject(this.reqInterceptor);
            axios.interceptors.response.eject(this.resInterceptor);
        }

        errorConfirmedHandler = () => {
            this.setState({error: null});
        };

        render() {
            let errorModal = null;
            const {error} = this.state;

            if (error) {
                if (error.response && error.response.status === 404) {
                    return <Redirect from="/projekte/:id" to="/wie-gehts-weiter"/>;
                }

                const errorMessage =
                    error.response && error.response.data
                        ? error.response.data
                        : error.message || 'Ein unbekannter Fehler ist aufgetreten';

                const errorTitle = error.response?.status
                    ? `Fehler: ${error.response.status}`
                    : 'Ein Fehler ist aufgetreten';

                errorModal = (
                    <Modal
                        isOpen={!!error}
                        toggle={this.errorConfirmedHandler}
                        centered
                        aria-labelledby="error-modal-title"
                        keyboard
                    >
                        <ModalHeader toggle={this.errorConfirmedHandler} id="error-modal-title">
                            {errorTitle}
                        </ModalHeader>
                        <ModalBody>
                            <div id="error-modal-description">
                                {typeof errorMessage === 'string' && errorMessage.includes('<') ? (
                                    <div dangerouslySetInnerHTML={{__html: errorMessage}}/>
                                ) : (
                                    <p>{String(errorMessage)}</p>
                                )}
                            </div>
                        </ModalBody>
                        <ModalFooter>
                            <Button color="secondary" onClick={this.errorConfirmedHandler}>
                                Schließen
                            </Button>
                        </ModalFooter>
                    </Modal>
                );
            }

            return (
                <>
                    {errorModal}
                    <WrappedComponent {...this.props} />
                </>
            );
        }
    };
};

export default withErrorHandler;